import { Link } from '@tanstack/react-router';
import { Icon } from '../../components/Icon.tsx';
import { bookDemoUrl } from './contact.ts';

/**
 * The sign-off. Previously a full mint primary-container panel; now it is just
 * the invitation, set large and centred with a lot of air around it. The only
 * saturated element is the one button you are meant to press — which is the
 * whole point of a closing CTA.
 */
export function ClosingCTA(): JSX.Element {
  return (
    <section className="folio-wide py-16 text-center sm:py-32">
      <div className="reveal mx-auto max-w-2xl">
        <span className="chip-dv">ފަށާ</span>
        <h2 className="head-dv mt-4 text-[2.2rem] leading-[1.3] sm:text-[3.2rem] sm:leading-[1.25]">
          ތިޔަ ކައުންސިލް ޒަމާނީކުރަން ތައްޔާރުތޯ؟
        </h2>
        <p className="mx-auto mt-6 max-w-lg leading-loose text-muted-foreground">
          ވެޕްލިފައި އޮފީސް ތިޔަ ރަށަށް ފެތޭ ގޮތް ބައްލަވާލައްވާ — ތިން ޓޫލްވެސް އަޅުގަނޑުމެން ދައްކާލަދޭނަން.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <a href={bookDemoUrl} target="_blank" rel="noreferrer" className="btn-primary !text-base">
            ޑެމޯއަކަށް ރިކުއެސްޓްކުރޭ <Icon name="arrow_back" size={18} />
          </a>
          <Link to="/login" className="btn-ghost !text-base">
            ލޮގިން
          </Link>
        </div>
      </div>
    </section>
  );
}
